import { render, staticRenderFns } from "./BiddingAgent.vue?vue&type=template&id=b1727646&scoped=true&"
import script from "./BiddingAgent.vue?vue&type=script&lang=js&"
export * from "./BiddingAgent.vue?vue&type=script&lang=js&"
import style0 from "./BiddingAgent.vue?vue&type=style&index=0&id=b1727646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1727646",
  null
  
)

export default component.exports